// メッセージカードフォームの制御
const caller = document.getElementById('Message-card-flag');
function messageCardToggle(){
	if(caller.checked){
		document.getElementById('Message-card-text').disabled = false;
		document.getElementById('Message-card-text-form').style.display = 'block';        
	}else{
		document.getElementById('Message-card-text').disabled = true;
		document.getElementById('Message-card-text-form').style.display = 'none';
	}
}
// 初回に一度実行
window.addEventListener('pageshow', function () {
	messageCardToggle(caller);
});